import { BaseActions } from './baseActions';
import { BaseReducer } from './baseReducer';
export class BaseActionReducer {
    constructor(keyStartAndPayloadName) {
        this.keyStartAndPayloadName = keyStartAndPayloadName;
    }
    buildReducer() {
        if (!this.baseReducer)
            this.baseReducer = new BaseReducer(this.keyStartAndPayloadName);
        return this.baseReducer.buildReducer();
    }
    buildSyncActions() {
        if (!this.baseActions)
            this.baseActions = new BaseActions(this.keyStartAndPayloadName);
        return this.baseActions.buildSyncActions();
    }
    createAsyncAction(promise) {
        if (!this.baseActions)
            this.baseActions = new BaseActions(this.keyStartAndPayloadName);
        return this.baseActions.createAsyncAction(promise);
    }
}
